import axios from 'axios'

export default {

  validatePassword(emailId, password) {
    return axios({
      method: 'post',
      url: 'emails/' + emailId + '/validate-password',
      data: { password }
    })
  }
}
